const getters = {
  commitToolBar({ commit }, data) {
    commit("setToolData", data);
    commit("setCacheView", data);
  },
  clearToolBar({ commit }, data) {
    commit("clearToolItem", data.detail);
  },
  clearCache({ commit }, data) {
    commit("clearCacheView", data);
  },
  addOrderCount({ commit }, data) {
    commit("addOrderCount", data);
  },
};
export default getters;
